import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { logoUrl } from '../data';
import { adminNavGroups } from './adminModules';
import './admin-polish.css';

const { FiLogOut, FiX, FiExternalLink } = FiIcons;

function AdminSidebar({ active, open, onChange, onClose, onLogout, paymentBadge = 0 }) {
  return (
    <>
      <button
        className={`admin-nav-backdrop ${open ? 'open' : ''}`}
        onClick={onClose}
        aria-label="Close admin navigation"
      />
      <aside className={`admin-sidebar ${open ? 'open' : ''}`}>
        {/* Clean Logo Header */}
        <div className="admin-sidebar-header">
          <Link className="admin-brand-logo" to="/admin">
            <img
              src={logoUrl}
              alt="ZEVI"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <div className="admin-brand-text">
              <span className="brand-title">ZEVI</span>
              <span className="brand-sub">ADMINISTRATION</span>
            </div>
          </Link>
          <button className="admin-mobile-close" onClick={onClose} aria-label="Close menu">
            <SafeIcon icon={FiX} />
          </button>
        </div>

        {/* Navigation Groups */}
        <div className="admin-nav-body">
          {adminNavGroups.map((group) => (
            <div className="admin-nav-group" key={group.group}>
              <span className="admin-group-title">{group.group}</span>
              <nav className="admin-group-links">
                {group.items.map((item) => {
                  const isActive = active === item.id;
                  const showBadge = item.badgeKey === 'paymentReview' && paymentBadge > 0;
                  return (
                    <button
                      className={`admin-nav-item ${isActive ? 'active' : ''}`}
                      key={item.id}
                      onClick={() => {
                        onChange(item.id);
                        onClose();
                      }}
                    >
                      <span className="nav-icon">
                        <SafeIcon icon={item.icon} />
                      </span>
                      <span className="nav-label">{item.label}</span>
                      {showBadge && (
                        <span className="nav-counter">{paymentBadge}</span>
                      )}
                    </button>
                  );
                })}
              </nav>
            </div>
          ))}
        </div>

        {/* Sidebar Footer */}
        <div className="admin-sidebar-footer">
          <Link className="admin-footer-btn" to="/" target="_blank" rel="noreferrer">
            <SafeIcon icon={FiExternalLink} />
            <span>View Live Website</span>
          </Link>
          <button className="admin-footer-btn logout" onClick={onLogout}>
            <SafeIcon icon={FiLogOut} />
            <span>Sign Out</span>
          </button>
        </div>
      </aside>
    </>
  );
}

export default AdminSidebar;